import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel';
import PanelList from 'Components/PanelList/PanelList';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';

const AnalyticsListAssingment = (
    {
        onUpdateResetFilterDay,
        resetFilterDay,
        sectorSelected,
        managerSelected,
        employeeSelected,
        selectedActualDate
    }) => {
    const PanelListStyle = {
        display: 'flex',
        flexDirection: 'column',
        minWidth: '40%',
        maxWidth: '40%',
    };
    const [usersScheduledDay, setUsersScheduledDay] = useState([]);
    const [IdScheduleSelected, setIdScheduleSelected] = useState([]);

    async function deletePeriodCalendar(scheduleIdDelete) {
        if (scheduleIdDelete && scheduleIdDelete.length===1) {
            const parameters = {
                scheduleId: scheduleIdDelete[0]
            };

            return await ExecuteAxios.api('delete', `/schedule`, { params: parameters });
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            setUsersScheduledDay(await getUsersScheduledDay());
        };
        fetchData();

        if (resetFilterDay) {
            onUpdateResetFilterDay(false);
        }
    }, [sectorSelected, managerSelected, employeeSelected, resetFilterDay]);

    async function getUsersScheduledDay() {
        let selectedActualDateISO;
        if (selectedActualDate) {
            selectedActualDateISO = selectedActualDate.toISOString()
        }
        const parameters = {
            sectorId: sectorSelected,
            managerId: managerSelected,
            employeeId: employeeSelected,
            dtAssignment: selectedActualDateISO
        }

        setIdScheduleSelected([]);
        return await ExecuteAxios.api('get', `/assignment/assignment-filter/`, { params: parameters });
    }

    return (
        <>
            <Panel titlePage={'Acionamentos mês'}
                style={PanelListStyle}
                canViewCRUD={true}
                canDelete={true}
                deleteFunction={deletePeriodCalendar}
                recordsSelected={IdScheduleSelected}
            >
                <PanelList
                    onUpdateIdSelected={setIdScheduleSelected}
                    idsSelected={IdScheduleSelected}
                    list={usersScheduledDay}
                >
                    <div className="cell first-cell"></div>
                    <div className="cell first-cell">Setor</div>
                    <div className="cell first-cell">Colaborador</div>
                    <div className="cell first-cell">Gerente</div>
                    <div className="cell first-cell">Ordem de serviço</div>
                    <div className="cell first-cell">Função do sistema</div>
                    <div className="cell first-cell">Descrição</div>
                    <div className="cell first-cell">Data do acionamento</div>
                    <div className="cell first-cell">Horário início</div>
                    <div className="cell first-cell">Horário fim</div>
                </PanelList>
            </Panel >
        </>
    )
};

export default AnalyticsListAssingment;
